// _interface.js
//  O.mode(0/1) off/on
//
// O.put(label,data)-出力

(function (mod) {
	if (typeof exports === "object") { //is browserify
		module.exports = mod();
		$=require("./../../bower_components/jquery/dist/jquery.js");
	}else{ //is html script tag
		window.O = mod();
	}
})(function (){
var Mo = (function (){

/////////////////////////////////////////////////////////////////////////
// ↓ INTERFACE TOOL ↓
/////////////////////////////////////////////////////////////////////////
var $=require("./../../bower_components/jquery/dist/jquery.js");
var INTERFACE = false;
var COLOR,BGCOLOR,WEIGHT;
var HIDDEN=0;

function _mode(m,c,bg,w,h){
	INTERFACE = m;
	COLOR = c||"#fff";
	BGCOLOR = bg||"rgba(50,50,50,0.9)";
	WEIGHT = w||"normal";
	HIDDEN = h||0;
}

	
function _set(n){
	if(INTERFACE&&!$("#x_x_interface")[0]){
		$("body").prepend('<ul id="x_x_interface" style="background-color:'+BGCOLOR+';font-family:\'Osaka\',\'Arial\';font-weight:'+WEIGHT+';position:fixed;display:block;z-index:9999;font-size:12px;color: '+COLOR+';display: block;padding: 10px 10px 0 10px;margin: 10px;border: 0px solid #0f0;text-align: left;"></ul>');
		hide(HIDDEN);
		$(window).on("keydown",function(e){
			if(e.keyCode===81){
				HIDDEN*=-1;
				hide(HIDDEN);
			}
			return false;
		});
	}
	$("#x_x_interface").append('<li id="'+n+'" style="display: block;position: relative;margin: 0px;padding: 0px;margin-bottom: 10px;">'+n+'\t : <span style="display:inline ;position: relative;margin: 0px;padding: 0px;" id="'+n+'">'+n+'</div></li>');
}
	
function hide(h){
	if(h>0){
		$("#x_x_interface").fadeOut(200);
	}else{
		$("#x_x_interface").fadeIn(200);
	}
	return false;
}

function _put(n,l){
	if(INTERFACE){
		if(!$("ul#x_x_interface > li#"+n)[0]){
			_set(n);
		}
		$("li#"+n+">span").html(l);
	}
}


// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
return {
	mode:_mode,
	set:_set,
	put:_put
};
/////////////////////////////////////////////////////////////////////////

})();
return Mo;
});



